import { Subscription } from 'rxjs/Rx';

export class SubscriptionHelper {
    public static unsubscribeHandler(subscription: Subscription): Subscription {
        if (subscription && !subscription.closed) {
            subscription.unsubscribe();
        }

        return subscription = null;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/helpers/subscription-helper.ts